import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

interface MemberQRCodeProps {
  /** Data URL from useMemberQRCode; empty while loading or on failure. */
  src: string;
  loading: boolean;
  error: boolean;
  /** Rendered edge length in px. */
  size: number;
}

/**
 * Renders the member QR image returned by the backend.
 *
 * <p>The endpoint produces a fixed 300x300 PNG, so smaller sizes are a browser downscale. `pixelated`
 * keeps QR module edges hard — smoothing a 3.75x downscale to 80px blurs them enough to risk
 * scannability.</p>
 */
const MemberQRCode: React.FC<MemberQRCodeProps> = ({ src, loading, error, size }) => {
  const { t } = useTranslation('layout');

  if (loading) {
    return (
      <div className="member-qrcode member-qrcode--loading" style={{
        width: size,
        height: size
      }}>
        <Spin />
      </div>
    );
  }

  if (error || !src) {
    return (
      <div className="member-qrcode member-qrcode--error" style={{
        width: size,
        height: size
      }}>
        {t('header.qrCodeNotAvailable')}
      </div>
    );
  }

  return (
    <img
      className="member-qrcode"
      src={src}
      alt={t('header.scanQRCode')}
      width={size}
      height={size}
      style={{ imageRendering: 'pixelated' }}
    />
  );
};

export default MemberQRCode;
